import { isHexColor } from './ColorField';

interface PassPreviewProps {
  name: string;
  logo?: string;
  strip?: string;
  icon?: string;
  labelColor: string;
  textColor: string;
  backgroundColor: string;
}

const hex = (value: string, fallback: string) => (isHexColor(value) ? `#${value}` : fallback);

export const PassPreview = ({ name, logo, strip, icon, labelColor, textColor, backgroundColor }: PassPreviewProps) => {
  const label = { color: hex(labelColor, '#6B7280') };
  const text = { color: hex(textColor, '#111827') };

  return (
    <figure className="flex flex-col gap-2">
      <div
        className="w-full max-w-[320px] overflow-hidden rounded-xl border border-gray-200 shadow-sm"
        style={{ backgroundColor: hex(backgroundColor, '#FFFFFF') }}
      >
        <div className="flex h-12 items-center justify-between gap-3 px-3">
          {logo ? (
            <img src={logo} alt="" className="h-7 max-w-[160px] object-contain object-left" />
          ) : (
            <div className="h-7 w-24 rounded bg-black/10" />
          )}
          <div className="text-right">
            <div className="text-[10px] font-semibold uppercase tracking-wide" style={label}>
              Program
            </div>
            <div className="max-w-[120px] truncate text-sm font-semibold" style={text}>
              {name.trim() || 'Program name'}
            </div>
          </div>
        </div>
        {strip ? (
          <img src={strip} alt="" className="h-24 w-full object-cover" />
        ) : (
          <div className="h-24 w-full bg-black/10" />
        )}
        <div className="grid grid-cols-2 gap-3 px-3 py-3">
          <div>
            <div className="text-[10px] font-semibold uppercase tracking-wide" style={label}>
              Member
            </div>
            <div className="text-sm font-medium" style={text}>
              Ada Obi
            </div>
          </div>
          <div className="text-right">
            <div className="text-[10px] font-semibold uppercase tracking-wide" style={label}>
              Valid until
            </div>
            <div className="text-sm font-medium" style={text}>
              Dec 31
            </div>
          </div>
        </div>
        <div className="flex justify-center pb-4">
          <div className="h-16 w-16 rounded bg-white p-1.5">
            <div className="h-full w-full rounded-sm bg-[repeating-linear-gradient(90deg,#111_0_3px,#fff_3px_6px)]" />
          </div>
        </div>
      </div>
      <figcaption className="flex items-center gap-2 text-xs text-gray-500">
        {icon && <img src={icon} alt="" className="h-5 w-5 rounded object-contain" />}
        Approximate preview. Wallet apps lay passes out differently.
      </figcaption>
    </figure>
  );
};
